<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <form class="form form-vertical row">
        <core-card [actions]="[]" class="col-12">
          <div class="card-body pb-0">
            <div class="row border-bottom align-items-center" [formGroup]="formGroup">
              <div class="form-group col-lg-4 col-12">
                <label for="client">{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="client"
                  (change)="formGroup.patchValue({ referent: null }); changeReferentList()"
                  class="{{ fieldHasErrors('client') ? 'is-invalid' : '' }}"
                  formControlName="client"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="customerService.customersList"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.client.errors?.required">{{ "ERRORS.INSERT_CUSTOMER" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <div class="d-flex justify-content-between">
                  <label for="referent">{{ "CUSTOMER_REFERENCE" | translate }}<sup class="text-danger">*</sup></label>
                  <label *ngIf="formGroup.value.client && _authenticationService.hasCapability('create_customer_referent')" class="cursor-pointer text-primary" (click)="toggleModalAdd = true">{{
                      "ADD_NEW_CUSTOMER_REFERENCE" | translate
                    }}</label>
                </div>
                <ng-select
                  bindValue="id"
                  bindLabel="complete_name"
                  id="referent"
                  class="{{ fieldHasErrors('referent') ? 'is-invalid' : '' }}"
                  formControlName="referent"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="filter_references_list"
                  [readonly]="!formGroup.value.client"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.referent.errors?.required">{{ "ERRORS.INSERT_CUSTOMER_REFERENCE" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <label for="commercial">{{ "CUSTOMER_COMMERCIAL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="hash"
                  bindLabel="complete_name"
                  id="commercial"
                  class="{{ fieldHasErrors('commercial') ? 'is-invalid' : '' }}"
                  formControlName="commercial"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="commercialUsers"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.commercial.errors?.required">{{ "ERRORS.INSERT_CUSTOMER_COMMERCIAL" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12 mb-2">
                <label for="city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="nice_name"
                  id="city"
                  class="{{ fieldHasErrors('city') ? 'is-invalid' : '' }}"
                  formControlName="city"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="_citiesService.list"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.city.errors?.required">{{ "ERRORS.SELECT_CITY" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12 mb-2">
                <label for="site">{{ "JOB_SITE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="site"
                  formControlName="site"
                  [items]="_jobSiteService.list"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  class="{{ fieldHasErrors('site') ? 'is-invalid' : '' }}"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.site.errors?.required">{{ "ERRORS.SELECT_JOB_SITE" | translate }}</div>
              </div>
              <div class="form-group col-lg-3 col-12 mb-2 pt-2" ngClass.xl="text-right">
                <div class="custom-control custom-control-primary custom-switch">
                  <span class="mr-1">{{ "SET_AS_PRIORITY_REQUEST" | translate }}</span>
                  <input id="priority" type="checkbox" checked class="custom-control-input" formControlName="priority" />
                  <label class="custom-control-label" for="priority"></label>
                </div>
              </div>
            </div>
            <div class="row border-bottom mt-2" [formGroup]="formGroup">
              <div class="form-group col-lg-4 col-xl-6 col-12">
                <label for="figure">{{ "PROFESSIONAL_FIGURE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="figure"
                  class="{{ fieldHasErrors('figure') ? 'is-invalid' : '' }}"
                  formControlName="figure"
                  [items]="_userFigureService.list"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [multiple]="true"
                  maxSelectedItems="2"
                >
                </ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.figure.errors?.required">{{ "INSERT.INSERT_FIGURE" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-xl-6 col-12">
                <label for="rate">{{ "RATE" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" id="rate" class="form-control {{ fieldHasErrors('rate') ? 'is-invalid' : '' }}" formControlName="rate" (change)="formatRate()" />
                </div>
                <div class="invalid-feedback" *ngIf="formGroup.controls.rate.errors?.required">{{ "ERRORS.INSERT_CODE" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-xl-4 col-12 mb-2">
                <label for="education_title">{{ "EDUCATION_TITLE" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="education_title"
                  formControlName="education_title"
                  [items]="_educationTitleService.list"
                  [closeOnSelect]="true"
                  [clearable]="true"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.education_title.errors?.required">{{ "ERRORS.INSERT_CODE" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-xl-4 col-12 mb-2">
                <label for="certifications">{{ "CERTIFICATIONS" | translate }}</label>
                <ng-select
                  bindValue="id"
                  bindLabel="name"
                  id="certifications"
                  [formControlName]="'certifications'"
                  [items]="_certificationService.list_enabled"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [multiple]="true"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="formGroup.controls.certifications.errors?.required">{{ "ERRORS.INSERT_CODE" | translate }}</div>
              </div>

              <div class="form-group col-lg-6 col-xl-4 col-12">
                <label for="languages">{{ "LANGUAGES" | translate }}</label>
                <ng-select id="languages" [searchable]="true" [closeOnSelect]="true" [formControlName]="'languages'" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [multiple]="true">
                  <ng-option *ngFor="let language of languages_list" [value]="language">{{ language }}</ng-option>
                </ng-select>
              </div>
            </div>

            <div class="row border-bottom mt-2" [formGroup]="formGroup">
              <div class="form-group col-12 mb-2">
                <label for="description">{{ "DESCRIPTION" | translate }}<sup class="text-danger">*</sup></label>
                <angular-editor id="description" [config]="_utilService.defaultEditorConfig" [formControlName]="'description'" class="{{ fieldHasErrors('description') ? 'is-invalid' : '' }}"></angular-editor>
                <div class="invalid-feedback" *ngIf="formGroup.controls.description.errors?.required">{{ "ERRORS.INSERT_DESCRIPTION" | translate }}</div>
                <div class="invalid-feedback" *ngIf="formGroup.controls?.description?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
              </div>
            </div>

            <!---------------------SKILL SECTION------------------------>
            <div class="row mt-2">
              <h3 class="ml-1 mb-1">{{ "INSERT.ADD_REQUEST_SKILLS" | translate }}</h3>
            </div>
            <div class="row border-bottom align-items-center py-1" [formGroup]="formGroup" *ngFor="let item of items_skills; let i = index">
              <div class="form-group col-lg-3 col-12">
                <label [for]="'skill_' + i">{{ "SKILLS" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  [id]="'skill_' + i"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  class="{{ !item.skill && showErrors ? 'is-invalid' : '' }}"
                  [virtualScroll]="true"
                  [items]="_skillService.list_enabled"
                  [(ngModel)]="item.skill"
                  [ngModelOptions]="{ standalone: true }"
                >
                </ng-select>
                <div class="text-danger font-error" *ngIf="!item.skill && showErrors">{{ "ERRORS.FIELD_SKILLS" | translate }}</div>
              </div>

              <div class="form-group col-lg-3 col-12">
                <label [for]="'level_' + i">{{ "SENIORITY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  [id]="'level_' + i"
                  [closeOnSelect]="true"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [(ngModel)]="item.level"
                  [ngModelOptions]="{ standalone: true }"
                  class="{{ !item.level ? 'is-invalid' : '' }}"
                >>
                  <ng-option value="junior">{{ "JUNIOR" | translate }}</ng-option>
                  <ng-option value="middle">{{ "MIDDLE" | translate }}</ng-option>
                  <ng-option value="senior">{{ "SENIOR" | translate }}</ng-option>
                </ng-select>
                <div class="text-danger font-error" *ngIf="!item.level">{{ "ERRORS.FIELD_SENIORITY" | translate }}</div>
              </div>

              <div class="form-group col-lg-3 col-12">
                <div class="row ml-025 mt-2">
                  <div class="custom-control custom-control-success custom-switch">
                    <span class="mr-2">{{ "SET_AS_REQUESTED_SKILL" | translate }}</span>
                    <input
                      (change)="setMaxThreeSkillsAsRequested(item, i)"
                      type="checkbox"
                      class="custom-control-input"
                      [disabled]="item.level === '' || item.skill < 1"
                      [id]="'skill_requested_' + i"
                      [(ngModel)]="item.requested"
                      [ngModelOptions]="{ standalone: true }"
                    />
                    <label class="custom-control-label" [for]="'skill_requested_' + i"></label>
                  </div>
                </div>
              </div>

              <div class="form-group col-lg-3 col-12 text-right mt-05">
                <button (click)="addSkillItem()" type="button" class="btn btn-outline-success btn-circle btn-sm mt-2" rippleEffect>
                  <i class="fa fa-plus text-success mt-025"></i>
                </button>
                <button *ngIf="items_skills.length > 1" (click)="deleteSkillItem(i)" type="button" class="btn btn-outline-danger btn-circle btn-sm mt-2 ml-2" rippleEffect>
                  <i class="fa fa-minus text-danger mt-025"></i>
                </button>
              </div>
            </div>
            <!---------------------END SKILL SECTION------------------------>
          </div>
          <div class="card-footer text-right">
            <button type="submit" rippleEffect class="btn btn-primary mr-1" (click)="createRequest()" *ngIf="_authenticationService.hasCapability('create_customer_request')">{{ "SAVE" | translate }}</button>
          </div>
        </core-card>
      </form>
    </section>
  </div>
</div>

<!-- Modal ADD -->
<app-form-add-customer-referent has_capability="create_customer_referent" *ngIf="toggleModalAdd" (callbackFn)="toggleModalAdd = false" (onAdd)="onReferentModalFormEvent($event)" [clientID]="formGroup.value.client"></app-form-add-customer-referent>
<!-- / Modal ADD -->
